import './accordion.scss'

( function( $ ) {
    $(document).ready(function () {
        $('.js-accordion').each(function () {
            const $accordion = $(this);
            const $toggleAccordion = $accordion.find('.js-toggleAccordion');
            const closeOthers = $accordion.data('close-others') !== false;

            $toggleAccordion.on('click', function() {
                const $accordionContent = $(this).next('.js-accordionContent');
                if (closeOthers) {
                    $accordion.find('.js-accordionContent').not($accordionContent).slideUp();
                    $accordion.find('.js-toggleAccordion').not(this).removeClass('-active');
                }
                $accordionContent.slideToggle();
                $(this).toggleClass('-active');
            });
        });
    });
} ) ( jQuery );